import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import Button from '../../components/atoms/Button/Button'
import CompleteSignup from '../../components/organisms/CompleteSignup/CompleteSignup'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import { CHANGE_SIGNUP_FORM, POST_SIGNUP } from '../../actions/authActions'
import './SignupPage.css'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'
import AuthForm, { FormType } from '../../components/organisms/AuthForm/AuthForm'
import { isEmptyObject } from '../../../commons/formValidator'
import InnerLink, { InnerLinkType } from '../../components/atoms/InnerLink/InnerLink'

export const SignupPageType = {
  INPUT_FORM: 1,
  COMPLETE: 2
}

class SignupPage extends PureComponent {
  render() {
    const {
      email,
      password,
      handleChangeForm,
      pageType,
      inputFormErrors,
      postSignup,
      isLoading,
      requestError
    } = this.props

    let title = '会員登録'
    let content = (
      <div>
        <AuthForm
          type={FormType.SIGNUP}
          email={email}
          password={password}
          handleChangeForm={handleChangeForm}
          errors={inputFormErrors}
        />

        {requestError && requestError.length > 0 ? <p styleName="errorMessage">{requestError}</p> : null}

        <div styleName="loginLink">
          <InnerLink to="/login" type={InnerLinkType.NORMAL}>
            <p styleName="text">すでに会員登録済みの方はこちら</p>
          </InnerLink>
        </div>
        <div styleName="button">
          <Button handleClick={postSignup} isLoading={isLoading} isEnabled={isEmptyObject(inputFormErrors)}>
            登録する
          </Button>
        </div>
      </div>
    )
    switch (pageType) {
      case SignupPageType.COMPLETE:
        title = '会員登録が完了しました'
        content = <CompleteSignup />
        break
    }
    return (
      <div styleName="background">
        <div styleName="container">
          <div styleName="backgroudImage">
            <ImageAsset type={ImageAssetType.TOP_VISUAL} />
          </div>
          <div styleName="mainContent">
            <div styleName="titlePart">
              <div styleName="logo">
                <Logo type={LogoType.GRAY} />
              </div>
              <h1 styleName="title">{title}</h1>
            </div>
            {content}
          </div>
        </div>
        <CommonFooter />
      </div>
    )
  }
}

SignupPage.propTypes = {
  // state
  pageType: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  inputFormErrors: PropTypes.object.isRequired,
  requestError: PropTypes.string,
  // dispatch
  handleChangeForm: PropTypes.func.isRequired,
  postSignup: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  email: state.auth.signupEmail,
  password: state.auth.signupPassword,
  pageType: state.auth.signupPageType,
  isLoading: state.auth.isSignupLoading,
  inputFormErrors: state.auth.signupInputFormErrors,
  requestError: state.auth.signupRequestError
})

const mapDispatchToProps = dispatch => ({
  handleChangeForm: data => dispatch(CHANGE_SIGNUP_FORM(data)),
  postSignup: () => dispatch(POST_SIGNUP())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupPage)
